import { TIER_STYLES, UNKNOWN_TIER_LABEL, UNKNOWN_TIER_VALUE } from './constants'

export const sortPrefixes = (prefixes = []) => [...prefixes].filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)))

export const getTierLabel = (tierLabels, tier) => {
  if (String(tier) === UNKNOWN_TIER_VALUE) return UNKNOWN_TIER_LABEL
  return tierLabels?.[tier] || tierLabels?.[String(tier)] || `T${tier}`
}

export const getTierStyle = (tier) => TIER_STYLES[String(tier)] || TIER_STYLES.unknown

export const getTierBadgeStyle = (tier) => {
  const style = getTierStyle(tier)
  return {
    backgroundColor: style.badge,
    borderColor: style.border,
    color: style.text,
  }
}

export const comparePrefixesByTierThenName = (ruleByPrefix, a, b) => {
  const aRule = ruleByPrefix.get(a)
  const bRule = ruleByPrefix.get(b)
  const aOrder = Number(aRule?.sizeOrder)
  const bOrder = Number(bRule?.sizeOrder)
  const aOrderRank = Number.isFinite(aOrder) ? aOrder : 999
  const bOrderRank = Number.isFinite(bOrder) ? bOrder : 999
  if (aOrderRank !== bOrderRank) return aOrderRank - bOrderRank
  const aTier = Number(aRule?.tier)
  const bTier = Number(bRule?.tier)
  const aRank = Number.isFinite(aTier) ? aTier : 999
  const bRank = Number.isFinite(bTier) ? bTier : 999
  return aRank - bRank || String(a).localeCompare(String(b))
}

export const sortRelationshipPrefixes = (prefixes, ruleByPrefix) =>
  [...(prefixes || [])].filter(Boolean).sort((a, b) => comparePrefixesByTierThenName(ruleByPrefix, a, b))

export const getRuleSizeOrder = (rule) => {
  const n = Number(rule?.sizeOrder)
  return Number.isFinite(n) ? n : 999
}

export const compareRulesBySizeOrder = (a, b) =>
  getRuleSizeOrder(a) - getRuleSizeOrder(b) ||
  Number(a?.tier ?? 999) - Number(b?.tier ?? 999) ||
  String(a?.prefix || '').localeCompare(String(b?.prefix || ''))

// ─── Product-linkage helpers (prefixProducts comes from GET /nesting-rules/prefix-products) ───

// "COPB · Carry On Pro" when a friendly label exists, else just the prefix code.
export const labelForPrefix = (prefix, prefixProducts) => {
  const entry = prefixProducts?.[prefix]
  if (!entry || !entry.derivedLabel || entry.derivedLabel === prefix) return prefix
  return `${prefix} · ${entry.derivedLabel}`
}

export const derivedLabelFor = (prefix, prefixProducts) => {
  const entry = prefixProducts?.[prefix]
  return entry?.derivedLabel && entry.derivedLabel !== prefix ? entry.derivedLabel : ''
}

export const productCount = (prefix, prefixProducts) => prefixProducts?.[prefix]?.matchCount ?? 0

// Derived, read-only views computed from the full rule set:
//  - heldBy: containers whose nestingRelationships include `prefix`
//  - accessoriesAccepted: accessory rules whose accessoryNesting includes `prefix`
export const inverseRelationships = (prefix, rules) => {
  const heldBy = []
  const accessoriesAccepted = []
  for (const r of rules || []) {
    if ((r.nestingRelationships || []).includes(prefix)) heldBy.push(r.prefix)
    if (r.flags?.isAccessory && (r.accessoryNesting || []).includes(prefix)) accessoriesAccepted.push(r.prefix)
  }
  return { heldBy: [...new Set(heldBy)], accessoriesAccepted: [...new Set(accessoriesAccepted)] }
}
